import React from 'react';
import './Form.css';

export default function Form() {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted');
  };

  return (
    <section>

      {/* -----------------------Name----------------------- */}
    <div className="form-wrap">
      <div className="form-card">
        <div className="form-left">
          <form className="form-form" onSubmit={handleSubmit}>
            <div className="field">
              <span className="label">Name</span>
              <input type="text" placeholder="Name" required />
            </div>
            <div className="field">
              <span className="label">Email</span>
              <input type="email" placeholder="Email" required />
            </div>
            <div className="field">
              <span className="label">Phone</span>
              <input type="text" placeholder="Phone" required />
            </div>
            <button type="submit" className="btn">Next</button>
          </form>
        </div>
        <div className="form-right">
          <img src="/assets/img1.png" alt="form image" className="form-image" />
        </div>
      </div>
    </div>



{/* ----------------------------Company detail--------------------- */}
     <div className="form-wrap">
      <div className="form-card">
        <div className="form-right">
          <img src="/assets/img2.png" alt="form image" className="form-image" />
        </div>
        <div className="form-left">
          <form className="form-form" onSubmit={handleSubmit}>
            <div className="field">
              <span className="label">Company Name</span>
              <input type="text" placeholder="Company Name" required />
            </div>
            <div className="field">
              <span className="label">Business Starting Year</span>
              <input type="date" placeholder="Business Starting Year" required />
            </div>
            <div className="field">
              <span className="label">Your Website URL</span>
              <input type="link" placeholder="Your Website URL" required />
            </div>
            <button type="submit" className="btn">Next</button>
          </form>
        </div>
        
      </div>
    </div>
    </section>
  );
}
